import { registerLocaleData } from '@angular/common';
import localeAr from '@angular/common/locales/ar';
import localeArExtra from '@angular/common/locales/extra/ar';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from 'app/app.component';
import { appConfig } from 'app/app.config';

// Arabic locale data must be registered before bootstrap so DatePipe/DecimalPipe/
// CurrencyPipe and Material can format dates and numbers in Arabic when LOCALE_ID is 'ar'.
registerLocaleData(localeAr, 'ar', localeArExtra);

bootstrapApplication(AppComponent, appConfig)
    .catch(err => console.error(err));
